var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spaceCenter" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading || _vm.isNetworkLoading,
            expression: "loading || isNetworkLoading",
          },
        ],
        staticClass: "exchange-card",
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "exchange-tab-body" },
          [
            _c("div", { staticStyle: { "margin-bottom": "0.2rem" } }, [
              _c("span", { staticClass: "word-sm" }, [_vm._v("Credit Check:")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: {
                    "credit-check-pending": !_vm.account,
                    "credit-check-passed": _vm.account && _vm.creditCheckStatus,
                    "credit-check-failed":
                      _vm.account && !_vm.creditCheckStatus,
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.account
                          ? _vm.creditCheckMessage
                          : "Pending (must mint REP at least twice)"
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.account
                ? _c(
                    "span",
                    {
                      staticClass: "credit-check-passed",
                      staticStyle: { color: "#929DAD" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.creditCheckStatus
                            ? "(2 REP mints completed)"
                            : "(At least 2 REP mints required)"
                        )
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  color: "#DCE0E7",
                  "font-size": "0.18rem",
                  "line-height": "0.23rem",
                  margin: "0.15rem 0",
                },
              },
              [_vm._v("Collateral:")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "spaceBetween exchange-item" }, [
              _c("div", { staticClass: "spaceLeft" }, [
                _c("img", {
                  staticStyle: { width: "0.44rem", "margin-right": "0.16rem" },
                  attrs: { src: require("@/assets/image/exchange/unit.png") },
                }),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "word-sm-black" }, [_vm._v("UNIT")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "word-sm",
                      staticStyle: { color: "rgb(86, 98, 122)" },
                    },
                    [_vm._v("Price: $" + _vm._s(_vm.unitPrice))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "exchange-input",
                    attrs: { placeholder: "0.00" },
                    on: {
                      input: function ($event) {
                        return _vm.exchangeInputUnit()
                      },
                      blur: function ($event) {
                        return _vm.exchangeInputUnit()
                      },
                    },
                    model: {
                      value: _vm.exchangeNumUnit,
                      callback: function ($$v) {
                        _vm.exchangeNumUnit = $$v
                      },
                      expression: "exchangeNumUnit",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-right word-sm-num",
                      staticStyle: { color: "#38F4BA" },
                    },
                    [
                      _vm._v(
                        "\n            Balance : " +
                          _vm._s(
                            _vm.account ? _vm.smallNum(_vm.balance) : "0.00"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  color: "#DCE0E7",
                  "font-size": "0.18rem",
                  "line-height": "0.23rem",
                  margin: "0.15rem 0",
                },
              },
              [_vm._v("Borrow:")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "spaceBetween exchange-item" }, [
              _c("div", { staticClass: "spaceLeft" }, [
                _c("img", {
                  staticStyle: { width: "0.44rem", "margin-right": "0.16rem" },
                  attrs: {
                    src: require("@/assets/image/exchange/TCashIcon.png"),
                  },
                }),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "word-sm-black" }, [
                    _vm._v("TCash"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "word-sm",
                      staticStyle: { color: "rgb(86, 98, 122)" },
                    },
                    [_vm._v("Price: $" + _vm._s(_vm.TCASHPrice))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-input", {
                    staticClass: "exchange-input",
                    attrs: { placeholder: "0.00" },
                    on: {
                      input: function ($event) {
                        return _vm.exchangeInputUSTN()
                      },
                      blur: function ($event) {
                        return _vm.exchangeInputUSTN()
                      },
                    },
                    model: {
                      value: _vm.exchangeNumUSTN,
                      callback: function ($$v) {
                        _vm.exchangeNumUSTN = $$v
                      },
                      expression: "exchangeNumUSTN",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-right word-sm-num",
                      staticStyle: { color: "#38F4BA" },
                    },
                    [
                      _vm._v("Borrowable :\n            "),
                      _vm.account
                        ? _c(
                            "span",
                            [
                              _c("big-number", {
                                attrs: { number: _vm.maximum, count: 2 },
                                on: {
                                  "update:number": function ($event) {
                                    _vm.maximum = $event
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v("\n              0.00\n            "),
                          ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.account
              ? _c(
                  "div",
                  {
                    staticClass: "spaceBetween risk-interest-info",
                    staticStyle: { "margin-bottom": "0.3rem" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#929DAD",
                          "font-size": "0.18rem",
                        },
                      },
                      [
                        _vm._v(
                          "\n          Risk Factors: " +
                            _vm._s(_vm.riskFactor) +
                            " %\n          "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              content:
                                "Your risk factor, based on personal credit and system conditions, determines how much TCash you can borrow.",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                color: "#929DAD",
                                "margin-left": "0.05rem",
                                cursor: "pointer",
                                "font-size": "0.16rem",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#929DAD",
                          "font-size": "0.18rem",
                        },
                      },
                      [
                        _vm._v(
                          "\n          Interest Rate: " +
                            _vm._s(_vm.dailyInterestRate) +
                            "%\n          "
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              content:
                                "Note: This is a daily interest rate. Borrowed TCash accrue interest daily.",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question",
                              staticStyle: {
                                color: "#929DAD",
                                "margin-left": "0.05rem",
                                cursor: "pointer",
                                "font-size": "0.16rem",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("checkLoginBtn", {
              attrs: { label: "Borrow TCash", needConnect: true },
              on: {
                clickHandle: _vm.submit,
                walletConnected: _vm.walletConnected,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "exchange-tab-box spaceCenter" }, [
      _c("img", {
        staticStyle: { width: ".35rem" },
        attrs: { src: require("@/assets/image/loan/title-icon.svg"), alt: "" },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Borrow TCash")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }